// TableRow.jsx
import React, { useState } from "react";
import { getValue } from "./utils";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import DynamicButton from "../DynamicButton/DynamicButton";
import "./TableRow.css";

const stop = (e) => e.stopPropagation();

// helper to render safe values
const renderCellValue = (val) => {
  if (!val) return "—";

  // If it's an array of objects
  if (Array.isArray(val)) {
    return val
      .map((item) => {
        if (typeof item === "object") {
          return item?.name || item?.roleName || item?.projectName || item?._id;
        }
        return String(item);
      })
      .join(", ");
  }

  // If it's an object
  if (typeof val === "object") {
    return (
      val.name ||
      val.roleName ||
      val.projectName ||
      val._id ||
      JSON.stringify(val)
    );
  }

  // Default: primitive
  return String(val);
};

const TableRow = ({
  row,
  index,
  currentPage,
  itemsPerPage,
  columns,
  editingRow,
  handleInputChange,
  handleSave,
  handleDelete,
  handleEdit,
  setEditingRow,
  selectedRows,
  toggleRowSelect,
  onRowClick,
}) => {
  const [showConfirm, setShowConfirm] = useState(false);

  const requestDelete = (e) => {
    stop(e);
    setShowConfirm(true);
  };

  const confirmDelete = () => {
    setShowConfirm(false);
    handleDelete(row._id);
  };

  const cancelDelete = () => setShowConfirm(false);

  return (
    <>
      <tr
        className={`custom-table-row ${
          selectedRows.includes(row._id) ? "selected" : ""
        }`}
        onClick={() => onRowClick && onRowClick(row)}
      >
        {/* Checkbox column */}
        <td onClick={stop} className="custom-table-row-checkbox">
          <input
            type="checkbox"
            checked={selectedRows.includes(row._id)}
            onChange={() => toggleRowSelect(row._id)}
          />
        </td>

        {/* Data columns */}
        {columns.slice(0, 5).map((col, colIndex) => {
          const rawVal = getValue(row, col.field);
          const displayVal = renderCellValue(rawVal);
          return (
            <td key={colIndex} className="custom-table-row-cell">
              {editingRow === index ? (
                <input
                  type="text"
                  className="custom-table-input"
                  value={rawVal || ""}
                  onChange={(e) => handleInputChange(e, index, col.field)}
                  onClick={stop}
                />
              ) : (
                displayVal
              )}
            </td>
          );
        })}

        {/* Action buttons */}
        <td className="custom-table-row-actions" onClick={stop}>
          <div className="custom-table-row-actions-inline">
            <DynamicButton
              icon="fa-edit"
              size="md"
              variant="primary"
              onClick={() => handleEdit(row._id)}
              title="Edit this record"
            />
            <DynamicButton
              icon="fa-trash"
              size="md"
              variant="danger"
              onClick={requestDelete}
              title="Delete this record"
            />
          </div>
        </td>
      </tr>

      <ConfirmDialog
        open={showConfirm}
        title="Delete this record?"
        message="This action cannot be undone."
        confirmLabel="Delete"
        cancelLabel="Cancel"
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
        variant="danger"
      />
    </>
  );
};

export default TableRow;
